import random from 'toxilibs/random.js'
import Level from '../core/level.js'
import mathText from '../math_text.js'

const level = new Level({
    name: 'pythagorean_theorem',
    dependencies: [
        'levels_maths/simple_length',
        'levels_maths/int_squared'
    ]
})


function setPointsAndDisplay (q) {
    let ab = random.fairChoiceInt(1, 5, {name: 'ab'})
    let ac = random.fairChoiceInt(1, 5, {name: 'ac'})

    if (random.oneChanceIn(2)) {
        ab = -ab
    }

    if (random.oneChanceIn(2)) {
        ac = -ac
    }

    let geoScreen = q.addGeoScreen({
        noAxes: true,
        maxScale: 1000
    })

    let points = {
        a: {x: 0,  y: 0,  name: 'A', color: '#F00'},
        b: {x: ab, y: 0,  name: 'B', color: '#226ea5'},
        c: {x: 0,  y: ac, name: 'C', color: '#390'}
    }

    geoScreen.addPolygon({
        points: [points.a, points.b, points.c],
        color: '#666'
    })

    return {
        textAB: mathText.pointsDistance(points.a, points.b),
        textAC: mathText.pointsDistance(points.a, points.c),
        textBC: mathText.pointsDistance(points.b, points.c),
        ab,
        ac,
        bcSquare: ab * ab + ac * ac
    }
}


level.addQuestion({
    generator: function (q) {
        let r = setPointsAndDisplay(q)
        q.addText(r.textAB + ' ?')
        q.answer = Math.abs(r.ab)
    }
})


level.addQuestion({
    generator: function (q) {
        let r = setPointsAndDisplay(q)
        q.addText('carre(' + r.textAB + ') ?')
        q.answer = r.ab * r.ab
    }
})


level.addQuestion({
    generator: function (q) {
        let r = setPointsAndDisplay(q)
        q.addText('carre(' + r.textAB + ') + carre(' + r.textAC + ') ?')
        q.answer = r.bcSquare
    },
    times: 2
})


level.addQuestion({
    generator: function (q) {
        let r = setPointsAndDisplay(q)
        q.addText('carre(' + r.textAB + ') = ' + (r.ab * r.ab))
        q.addText('carre(' + r.textAC + ') = ' + (r.ac * r.ac))
        q.addText('carre(' + r.textBC + ') = ?')
        q.answer = r.bcSquare
    },
    errorExpected: true,
    times: 2
})


level.addQuestion({
    generator: function (q) {
        let r = setPointsAndDisplay(q)
        q.addText('carre(' + r.textAC + ') = ' + (r.ac * r.ac))
        q.addText('carre(' + r.textBC + ') = ?')
        q.answer = r.bcSquare
    },
    errorExpected: true
})



level.addQuestion({
    generator: function (q) {
        let r = setPointsAndDisplay(q)
        q.addText('carre(' + r.textBC + ') = ?')
        q.answer = r.bcSquare
    },
    times: 2
})



export default level

